import React from 'react';
import formatBytes from '@afosto/utils/string/formatBytes';
import { FormattedMessage, FormattedRelative } from 'react-intl';
import camelize from '@afosto/utils/string/camelize';
import Link from '@material-ui/core/Link';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import formatDate from '@afosto/utils/date/formatDate';
import isDefined from '@afosto/utils/isDefined';

export const date = cell => {
  if (cell) {
    return formatDate(cell);
  }

  if (!isDefined(cell)) {
    return '-';
  }

  return cell;
};

export const datetime = cell => {
  if (cell) {
    return formatDateTime(cell);
  }

  if (!isDefined(cell)) {
    return '-';
  }

  return cell;
};

export const timestamp = cell => {
  if (!isDefined(cell)) {
    return '-';
  }

  return datetime(cell * 1000);
};

export const relativeDate = cell => {
  if (!isDefined(cell)) {
    return '-';
  }
  return <FormattedRelative value={cell} />;
};

export const currency = (cell, row, formatOptions = {}) => {
  const options = {
    currency: 'EUR',
    ...formatOptions,
  };

  if (!isDefined(cell)) {
    return '-';
  }

  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: row?.currency || options.currency,
  }).format(cell / 100);
};

export const array = cell => (
  <Grid container spacing={1}>
    {cell?.length
      ? cell
          .filter(item => item !== '')
          .map(item => (
            <Grid key={item} item>
              <Chip label={item} size="small" />
            </Grid>
          ))
      : '-'}
  </Grid>
);

export const boolean = cell => {
  if (!isDefined(cell)) {
    return '-';
  }

  return (
    <FormattedMessage
      id={`properties.${cell ? 'yes' : 'no'}`}
      defaultMessage={cell ? 'Yes' : 'No'}
      description="Translation of boolean value"
    />
  );
};

export const bytes = cell => formatBytes(cell);

export const percentage = cell => {
  if (!isDefined(cell)) {
    return '-';
  }

  return `${cell}%`;
};

const getTranslatedValue = (cell, row, formatOptions = {}) => {
  if (!isDefined(cell)) {
    return '-';
  }

  if (!formatOptions.translationKey || formatOptions.translationKey.indexOf('{value}') < 0) {
    return cell;
  }

  return (
    <FormattedMessage
      id={formatOptions.translationKey.replace('{value}', camelize(cell))}
      description={`Translation of cell value ${cell}`}
      defaultMessage={cell}
    />
  );
};

export const translation = (cell, row, formatOptions = {}) => {
  if (Array.isArray(cell)) {
    return cell.map((value, idx) => (
      <React.Fragment key={value}>
        {getTranslatedValue(value, row, formatOptions)}
        {idx < cell.length - 1 ? ', ' : ''}
      </React.Fragment>
    ));
  }

  return getTranslatedValue(cell, row, formatOptions);
};

export const url = cell => {
  if (!isDefined(cell)) {
    return '-';
  }

  return (
    <Link variant="body2" href={cell} target="_blank">
      {cell}
    </Link>
  );
};
